import { createContext, useContext } from "react";

export const CountryContext = createContext();

export function useCountry() {
  return useContext(CountryContext);
}
